import { FwVersion } from '../hooks/useDevices'

type DeviceNameSubstring =
  | 'Cyclone'
  | 'Vortex'
  | 'Pulsar'
  | 'Actuator'
  | 'Singularity'
  | 'Skywalker'

export const MIN_FW_FOR_PARAM_DETECT_V2: {
  [key in DeviceNameSubstring]: FwVersion
} = {
  Cyclone: [4, 2, 0],
  Vortex: [1, 0, 0],
  Pulsar: [1, 0, 0],
  Actuator: [1, 0, 0],
  Singularity: [1, 0, 0],
  Skywalker: [1, 0, 0]
}

export const MIN_FW_FOR_OPEN_LOOP = MIN_FW_FOR_PARAM_DETECT_V2
